<template>
    <div>
        <ui-icon-button has-dropdown icon="inbox" type="secondary" style="vertical-align: middle;" tooltip="Transfer">
            <div slot="dropdown">
                <div class="container-fluid">
                    <div @click="setMessageBox(messageBox)" v-for="messageBox in messageBoxes" class="row align-items-center">
                        <div class="col-2"><span class="bs-dot"></span></div>
                        <div class="col">{{ messageBox.name }}</div>
                        <div class="col-4"><span v-if="isCurrentMessageBox(messageBox)" class="material-icons">check</span></div>
                    </div>
                </div>
            </div>
        </ui-icon-button>
    </div>
</template>

<script>
    export default {
        props: {
            conversations: {
              type: Array,
              required: true
            },
        },
        computed: {
            messageBoxes() {
                return this.$store.getters['inbox/messageBoxes/all']
            }
        },
        methods: {
            setMessageBox(messageBox) {
                let promises = []

                for (let i in this.conversations) {
                    promises.push(this.$store.dispatch(
                        'inbox/conversations/transfer', {
                            conversation_id: this.conversations[i].id,
                            message_box_id: messageBox.id
                        }
                    ))
                }

                Promise.all(promises).then(() => {
                    this.$emit('changed', messageBox)
                })
            },
            isCurrentMessageBox(messageBox) {
                if (this.conversations.length === 1) {
                    return this.conversations[0].message_box_id === messageBox.id
                }

                return false
            }
        }
    }
</script>

<style lang="scss" scoped>
    .bs-dot {
        margin-right: .25rem;
        vertical-align: middle;
        height: 16px; width: 16px;
        background: #999;
        border-radius: 50%;
        display: inline-block;
    }

    .container-fluid {
        .row {
            border-top: 1px solid #eee;
            padding-top: .5rem;
            padding-bottom: .5rem;
            cursor: pointer;

            &:hover { background: #f8f8f8; }
        }

        .material-icons { vertical-align: middle; }
    }
</style>